/**
 * Static sample data for guest (read-only showcase, no API).
 */
import { mockMissions } from "layouts/dashboardLayout/pages/Users/data/mockMissions";

export const guestMissions = mockMissions;

export const guestNonprofits = [
  {
    nonprofitId: "ORG-MAIN-001",
    id: "ORG-MAIN-001",
    name: "AviPair Relief Coordination",
    email: "coordination@avipair-sample.org",
    phone: "+1 (555) 100-2000",
    ein: "12-3456789",
    category: "disaster-relief",
    city: "Atlanta",
    state: "GA",
    url: "https://example.org",
    operationalStates: ["GA", "FL", "AL"],
  },
  {
    nonprofitId: "ORG-FIRE-002",
    id: "ORG-FIRE-002",
    name: "Western Fire Mutual Aid",
    email: "ops@wfma-sample.org",
    phone: "+1 (555) 200-3000",
    ein: "98-7654321",
    category: "animal-rescue",
    city: "Denver",
    state: "CO",
    operationalStates: ["CO", "ID", "WY"],
  },
  {
    nonprofitId: "ORG-001",
    id: "ORG-001",
    name: "Sample Supply Hub",
    email: "hub@example.org",
    ein: "11-2233445",
    category: "medical",
    city: "Miami",
    state: "FL",
    operationalStates: ["FL"],
  },
];

export const guestAirports = [
  {
    airportId: "ATL",
    id: "ATL",
    name: "Hartsfield-Jackson Atlanta International",
    email: "ops@atl.airport.example",
    phone: "+1 404-555-0100",
    airportUse: "public",
    airportOwnership: "public",
    address: "6000 N Terminal Pkwy",
    city: "Atlanta",
    state: "GA",
    managerName: "Terminal Operations",
    managerPhone: "+1 404-555-0101",
    url: "https://www.atl.com",
  },
  {
    airportId: "EYW",
    id: "EYW",
    name: "Key West International",
    email: "info@eyw.airport.example",
    phone: "+1 305-555-0200",
    airportUse: "public",
    airportOwnership: "public",
    address: "3491 S Roosevelt Blvd",
    city: "Key West",
    state: "FL",
    managerName: "FBO Manager",
    managerPhone: "+1 305-555-0201",
    url: "https://eyw.com",
  },
  {
    airportId: "DEN",
    id: "DEN",
    name: "Denver International",
    email: "ops@den.airport.example",
    phone: "+1 303-555-0300",
    airportUse: "public",
    airportOwnership: "public",
    address: "8500 Peña Blvd",
    city: "Denver",
    state: "CO",
    managerName: "Airside Coordinator",
    managerPhone: "+1 303-555-0301",
    url: "https://flydenver.com",
  },
  {
    airportId: "BOI",
    id: "BOI",
    name: "Boise Airport",
    email: "admin@boi.airport.example",
    phone: "+1 208-555-0400",
    airportUse: "public",
    airportOwnership: "private",
    address: "3201 W Airport Way",
    city: "Boise",
    state: "ID",
    managerName: "Operations Lead",
    managerPhone: "+1 208-555-0401",
    url: "https://iflyboise.com",
  },
];

/** Sample leaderboard rows (illustrative). */
export const guestLeaderboardRows = [
  {
    rank: 1,
    entity: "Angel Flight Southeast",
    type: "Non-profit",
    missions: 38,
    flightHours: 284,
  },
  {
    rank: 2,
    entity: "SkyBridge Volunteers",
    type: "Pilot network",
    missions: 31,
    flightHours: 241,
  },
  {
    rank: 3,
    entity: "Regional GA — KPDX",
    type: "Airport",
    missions: 27,
    flightHours: 198,
  },
  {
    rank: 4,
    entity: "Coastal Relief Alliance",
    type: "Non-profit",
    missions: 22,
    flightHours: 176,
  },
  {
    rank: 5,
    entity: "High Country Flyers",
    type: "Pilot network",
    missions: 19,
    flightHours: 142,
  },
];

export function getGuestMissionById(id) {
  if (id == null || id === "") return null;
  const sid = String(id);
  return (
    guestMissions.find(
      (m) => String(m.missionId ?? m.id ?? "") === sid,
    ) || null
  );
}
